<template>
  <div></div>
</template>

<script>
import { defineComponent, getCurrentInstance, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  setAuthorization,
  getAuthorization,
  checkAuthorization,
} from "@/utils/request";
export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    onMounted(() => {
      let info = route.query;
      console.log(info);
      let userInfo = {
        userid: info.userid,
        phone: info.phone,
        email: info.email,
        username: info.username,
      };
      localStorage.setItem("userInfo", JSON.stringify(userInfo));

      if (info.page == "index") {
        localStorage.setItem("openSuggest", true);
      }

      let t = new Date(new Date().getTime() + 30 * 60 * 1000);
      setAuthorization({
        token: info.token,
        expireAt: new Date(t),
      });

      if (checkAuthorization()) {
        router.push("/" + info.page);
      }
    });
  },
});
</script>
